import React from 'react';

interface SidebarProps {
    bgColor?: string;
    textColor1?: string;
    textColor2?: string;
    textColor3?: string;
    isMobile?: boolean;
}

const commonSidebarLayout = (WrappedComponent: React.ComponentType<SidebarProps>) => {
  const ResponsiveSidebar = (props: SidebarProps) => {
    // Detect if the viewport is mobile (you can use a library like `react-responsive` or a custom hook for this)
    const isMobile = window.innerWidth <= 768;

    // Assign styles dynamically based on device type
    const bgColor = isMobile ? 'bg-mobile' : 'bg-desktop';
    const textColor1 = isMobile ? 'text-mobile-primary' : 'text-desktop-primary';
    const textColor2 = isMobile ? 'text-mobile-secondary' : 'text-desktop-secondary';
    const textColor3 = isMobile ? 'text-mobile-tertiary' : 'text-desktop-tertiary';
    const device = isMobile ? 'sidebar-mobile-view' : 'sidebar-desktop-view';

    return (
    //   <div className={`newly sidebar-wrapper ${bgColor} ${textColor}`}>
    //     <WrappedComponent {...props} isMobile={isMobile} bgColor={bgColor} textColor={textColor} />
    //   </div>

        <div className={`dynamic-sidebar ${device}`}>
            {/* Pass props and new textColor values to the WrappedComponent */}
            <WrappedComponent
                {...props}
                isMobile={isMobile}
                bgColor={bgColor}
                textColor1={textColor1}
                textColor2={textColor2}
                textColor3={textColor3}
            />
        </div>

    );
  };

  return ResponsiveSidebar;
};

export default commonSidebarLayout;
